import { render, staticRenderFns } from "./canteenManagement.vue?vue&type=template&id=5cdcb3d3&scoped=true&"
import script from "./canteenManagement.vue?vue&type=script&lang=js&"
export * from "./canteenManagement.vue?vue&type=script&lang=js&"
import style0 from "./canteenManagement.vue?vue&type=style&index=0&id=5cdcb3d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cdcb3d3",
  null
  
)

export default component.exports